import { axios } from '@/utils/request'

const api = {
    weiyuanhuiList: '/adminapi/weiyuanhui/weiyuanhuiList',
    userDetail: '/adminapi/user/userdetail',
    userEdit: '/adminapi/user/useredit',
    userGroupList: '/adminapi/user/userGroupList',
    setPassword: '/adminapi/user/setPassword',
    userOptions: '/adminapi/user/userOptions',
    editPassword: '/adminapi/user/editPassword',
    wyhSetting: '/adminapi/weiyuanhui/wyhSetting',
    getWyhSetting: '/adminapi/weiyuanhui/getWyhSetting',
    getWyhUserList: '/adminapi/weiyuanhui/getWyhUserList',
    addWyhUser: '/adminapi/weiyuanhui/addWyhUser',
    deleteWyhUser: '/adminapi/weiyuanhui/deleteWyhUser',
    getSubWyhList: '/adminapi/weiyuanhui/getSubWyhList',
    getUserDownloadUrl: '/adminapi/weiyuanhui/getUserDownloadUrl',
    userScoreImport: '/adminapi/weiyuanhui/userScoreImport',
}

export default api

export function userScoreImport(parameter) {
    return axios({
        url: api.userScoreImport,
        method: 'post',
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        data: parameter
    })
}
export function getUserDownloadUrl(parameter) {
    return axios({
        url: api.getUserDownloadUrl,
        method: 'post',
        data: parameter
    })
}

export function getWeiyuanhuiList(parameter) {
    return axios({
        url: api.weiyuanhuiList,
        method: 'get',
        params: parameter
    })
}

export function editPassword(parameter) {
    return axios({
        url: api.editPassword,
        method: 'post',
        data: parameter
    })
}
export function getUserDetail(parameter) {
    return axios({
        url: api.userDetail,
        method: 'get',
        params: parameter
    })
}

export function editUser(parameter) {
    return axios({
        url: api.userEdit,
        method: 'post',
        data: parameter
    })
}

export function getUserGroupList(parameter) {
    return axios({
        url: api.userGroupList,
        method: 'get',
        params: parameter
    })
}
export function setPassword(parameter) {
    return axios({
        url: api.setPassword,
        method: 'get',
        params: parameter
    })
}


export function getUserOptions(parameter) {
    return axios({
        url: api.userOptions,
        method: 'get',
        params: parameter
    })
}



export function wyhSetting(parameter) {
    return axios({
        url: api.wyhSetting,
        method: 'post',
        data: parameter
    })
}
export function getWyhSetting(parameter) {
    return axios({
        url: api.getWyhSetting,
        method: 'post',
        data: parameter
    })
}
export function getWyhUserList(parameter) {
    return axios({
        url: api.getWyhUserList,
        method: 'post',
        data: parameter
    })
}
export function deleteWyhUser(parameter) {
    return axios({
        url: api.deleteWyhUser,
        method: 'post',
        data: parameter
    })
}
export function addWyhUser(parameter) {
    return axios({
        url: api.addWyhUser,
        method: 'post',
        data: parameter
    })
}
export function getSubWyhList(parameter) {
    return axios({
        url: api.getSubWyhList,
        method: 'post',
        data: parameter
    })
}